/**
 * The username field accepts either an E-Code or an email address, so the email
 * rules only apply once the value looks like an email (i.e. carries an "@").
 */
export const looksLikeEmail = (value: string): boolean => value.includes('@');

/** Pragmatic format check — mirrors what the browser's type="email" accepts. */
const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export const isValidEmail = (value: string): boolean => EMAIL_PATTERN.test(value.trim());
